// EditPopup.js
import React, { useState, useEffect } from 'react';
import './UserProfile.scss'

const EditPopup = ({ type, data, mode, onClose, onSave }) => {
  const [formData, setFormData] = useState(data || {});

  useEffect(() => {
    if (data) setFormData(data);
  }, [data]);

  const handleChange = (e) => {
    const { name, value, type: inputType, checked } = e.target;
    const val = inputType === 'checkbox' ? checked : value;
    setFormData({ ...formData, [name]: val });
  };

  const renderFields = () => {
    switch (type) {
      case 'education':
        return (
          <>
          <div className='inputs'>
            <input className='edit-input' name="school" value={formData.school || ''} onChange={handleChange} placeholder="School" />
            <input className='edit-input' name="degree" value={formData.degree || ''} onChange={handleChange} placeholder="Degree" />
            <input className='edit-input' name="eduenddate" type="date" value={formData.eduenddate || ''} onChange={handleChange} />
            </div>
          </>
        );
      case 'experience':
        return (
          <>
          <div className='inputs'>
            <input className='edit-input' name="company" value={formData.company || ''} onChange={handleChange} placeholder="Company" />
            <input className='edit-input' name="designation" value={formData.designation || ''} onChange={handleChange} placeholder="Designation" />
            <input className='edit-input' name="comstartdate" type="date" value={formData.comstartdate || ''} onChange={handleChange} />
            <input className='edit-input' name="comenddate" type="date" value={formData.comenddate || ''} onChange={handleChange} />
            <label>
              <input type="checkbox" name="currentlyWorking" checked={formData.currentlyWorking || false} onChange={handleChange} />
              Currently Working
            </label>
            </div>
          </>
        );
      case 'skills':
        return (
          <>
          <div className='inputs'>
            <input className='edit-input' name="skills" value={formData.skills || ''} onChange={handleChange} placeholder="Skills (comma-separated)" />
            <input className='edit-input' name="linkedIn" value={formData.linkedIn || ''} onChange={handleChange} placeholder="LinkedIn URL" />
            <input className='edit-input' name="gitHub" value={formData.gitHub || ''} onChange={handleChange} placeholder="GitHub URL" />
              <input className='edit-input' name="about" value={formData.about || ''} onChange={handleChange} placeholder="About" />
         </div>
          </>
        );
        case 'primaryContact':
        return (
          <>
          <div className='inputs'>
            <input className='edit-input' name="name" value={formData.name || ''} onChange={handleChange} placeholder="Name" />
            <input className='edit-input' name="email" value={formData.email || ''} onChange={handleChange} placeholder="Email" />
            <input className='edit-input' name="contactNumber" value={formData.contactNumber || ''} onChange={handleChange} placeholder="Contact Number" />
          </div>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div className="popup-overlay">
      <div className="edit-popup">
        <h3 className='edit-head'>{mode === 'edit' ? 'Edit' : 'Add'} {type}</h3>
        {renderFields()}
       
          <button onClick={onClose} className='edit-cancel'>Cancel</button>
          <button onClick={() => onSave(type, formData)} className='edit-save-btn'>Save</button>
       
      </div>
    </div>
  );
};

export default EditPopup;